export default "__VITE_ASSET__BcCYkXUr__"